import Whiteboard from 'components/framework/models/Whiteboard';
import WhiteboardVersion from 'components/framework/models/WhiteboardVersion';
import Debug from 'debug';
import { type RecordId } from '../../javascripts/shared-types';

const debug = Debug('whiteboard');

const fetchWhiteboardVersions = async (
  whiteboardId: RecordId
): Promise<Aha.WhiteboardVersion[]> => {
  debug('Fetching whiteboard versions for whiteboard %s', whiteboardId);

  const whiteboard = await Whiteboard.merge({
    versions: WhiteboardVersion.select('id', 'updatedAt').merge({
      authors: ['id', 'name', 'avatarUrl'],
    }),
  }).find(whiteboardId);

  if (!whiteboard) {
    throw new Error(`Missing whiteboard ${whiteboardId}`);
  }

  // @ts-expect-error Internal model type is incompatiable with the Aha.WhiteboardVersion type
  return whiteboard.versions as Aha.WhiteboardVersion[];
};

const fetchWhiteboardVersion = async (
  whiteboardId: RecordId,
  whiteboardVersionId: RecordId
): Promise<Aha.WhiteboardVersion> => {
  debug(
    'Fetching whiteboard version %s for whiteboard %s',
    whiteboardVersionId,
    whiteboardId
  );

  const whiteboard = await Whiteboard.select(
    `version(id: ${whiteboardVersionId}) {
      editorContent
    }`
  ).find(whiteboardId);

  if (!whiteboard) {
    throw new Error(`Missing whiteboard ${whiteboardId}`);
  }

  const version = whiteboard.version;

  if (!version) {
    throw new Error(`Missing whiteboard version ${whiteboardVersionId}`);
  }

  // @ts-expect-error Internal model type is incompatiable with the Aha.WhiteboardVersion type
  return version as Aha.WhiteboardVersion;
};

const createVersionSnapshot = async (whiteboardId: RecordId) => {
  return fetch(`/whiteboards/${whiteboardId}/whiteboard_versions`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': window.csrfToken(),
    },
  });
};

export default {
  fetchWhiteboardVersions,
  fetchWhiteboardVersion,
  createVersionSnapshot,
};
